export default __webpack_public_path__ + "static/media/error.7d32a059.gif";